import { Capacitor } from '@capacitor/core';
import { Stripe, PaymentSheetEventsEnum } from '@capacitor-community/stripe';

const APPLE_MERCHANT_ID = process.env.REACT_APP_APPLE_MERCHANT_ID || '';
const MERCHANT_DISPLAY_NAME = 'SkipdQ';
const COUNTRY_CODE = 'CA';
// Must match a URL scheme registered in ios/App/App/Info.plist (used for 3DS / bank redirects).
const RETURN_URL = 'skipdq://stripe-redirect';

let initializedKey = null;
let initPromise = null;

export function canUseNativePaymentSheet() {
  return Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios';
}

export function isApplePayConfigured() {
  return Boolean(APPLE_MERCHANT_ID);
}

async function ensureNativeStripe(publishableKey) {
  if (!publishableKey) throw new Error('Payments are not configured');
  if (initializedKey === publishableKey && initPromise) return initPromise;
  initializedKey = publishableKey;
  initPromise = Stripe.initialize({ publishableKey }).catch((err) => {
    initializedKey = null;
    initPromise = null;
    throw err;
  });
  return initPromise;
}

/**
 * Presents Stripe's native Payment Sheet (Apple Pay + card) for an existing PaymentIntent.
 * Resolves to 'completed' | 'canceled' | 'failed'.
 */
export async function payWithPaymentSheet({ publishableKey, clientSecret }) {
  if (!clientSecret) throw new Error('Missing payment details');
  await ensureNativeStripe(publishableKey);

  await Stripe.createPaymentSheet({
    paymentIntentClientSecret: clientSecret,
    merchantDisplayName: MERCHANT_DISPLAY_NAME,
    countryCode: COUNTRY_CODE,
    returnURL: RETURN_URL,
    enableApplePay: isApplePayConfigured(),
    applePayMerchantId: APPLE_MERCHANT_ID || undefined,
  });

  const { paymentResult } = await Stripe.presentPaymentSheet();
  switch (paymentResult) {
    case PaymentSheetEventsEnum.Completed:
      return 'completed';
    case PaymentSheetEventsEnum.Canceled:
      return 'canceled';
    default:
      return 'failed';
  }
}
